export default __webpack_public_path__ + "static/media/iconCamera.6f72365d.svg";